/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum DistanceUnit {
  KM="KM",
MILES="MILES"
}

/**
* DistanceUnit
*/
export const DistanceUnitEnumType = types.enumeration("DistanceUnit", [
        "KM",
  "MILES",
      ])
